import { IconAngleRight } from '@maia/icons';
import { QuotationDto } from '@maia/shared';
import { ActionButtonLink, Tag, Typography, Widget } from '@maia/ui';
import { formatCurrency } from '@maia/utils';

type QuotationCardProps = {
  quotation: QuotationDto;
};

export function RecentlyMadeQuotationCard(props: QuotationCardProps) {
  const { quotation } = props;
  return (
    <Widget
      title={{
        title: `#${quotation.reference}`,
        href: `/quotations/${quotation.guid}`,
      }}
      subtitle={quotation.customer.consumer.fullName}
      actions={[
        <ActionButtonLink
          icon={IconAngleRight}
          size="small"
          to={`/quotations/${quotation.guid}`}
        />,
      ]}
      padding="large"
    >
      <Typography
        variant="body-xs"
        weight="medium"
        className="text-grayscale300"
      >
        {formatCurrency(quotation.price)}
      </Typography>

      <Tag label={quotation.status.label} variant={quotation.status.variant} />
    </Widget>
  );
}
